import isNil from 'lodash/isNil';

export const getMaxLengthValidator = (maxLength) => (value) =>
  (!isNil(value) && value.trim().length > maxLength
    ? `Please enter a maximum of ${maxLength} characters.`
    : undefined);
